export default __webpack_public_path__ + "static/media/thumb-banner1.f79fc717.jpg";